import { render } from "./WithdrawalRuleModal.vue?vue&type=template&id=39cad10e&scoped=true"
import script from "./WithdrawalRuleModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalRuleModal.vue?vue&type=script&lang=js"

import "./WithdrawalRuleModal.vue?vue&type=style&index=0&id=39cad10e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cad10e"]])

export default __exports__